import * as React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Checkbox } from "../../../../components/ui/checkbox";
import { Label } from "../../../../components/ui/label";
import {
  Select, SelectTrigger, SelectValue, SelectContent,
  SelectItem, SelectGroup, SelectLabel,
} from "../../../../components/ui/select";
import { trailerInterchangeLimitOptions } from "data"; // <-- your data module

export function TISection() {
  const { control, watch, setValue } = useFormContext();
  const hasTI = watch("step8.trailer_interchange");

  return (
    <div className="space-y-3 my-1 rounded-lg border p-4">
      <div className="flex items-center gap-3">
        <Controller
          control={control}
          name="step8.trailer_interchange"
          render={({ field }) => (
            <Checkbox
              id="cov-trailer-int"
              checked={!!field.value}
              onCheckedChange={(v) => {
                field.onChange(v);
                setValue("step8.trailer_interchange_limit", v ? "unselected" : undefined);
              }}
            />
          )}
        />
        <Label htmlFor="cov-trailer-int" className="cursor-pointer">
          Trailer Interchange
        </Label>
      </div>

      {hasTI && (
        <div className="space-y-2">
          <Label>
            Trailer Interchange Limit <span className="text-red-600">*</span>
          </Label>
          <Controller
            control={control}
            name="step8.trailer_interchange_limit"
            render={({ field, fieldState }) => (
              <>
                <Select value={(field.value) ?? "unselected"} onValueChange={field.onChange} onOpenChange={() => field.onChange(field.value)}>
                  <SelectTrigger className="w-full !h-10 py-2 px-3">
                    <SelectValue placeholder="Please select an option" />
                  </SelectTrigger>
                  <SelectContent className="max-h-60 overflow-y-auto">
                    <SelectGroup>
                      <SelectLabel>Limits</SelectLabel>
                      <SelectItem value="unselected">Please select an option</SelectItem>
                      {trailerInterchangeLimitOptions.map((o) => (
                        <SelectItem key={o.value} value={o.value}>
                          {o.label}
                        </SelectItem>
                      ))}
                    </SelectGroup>
                  </SelectContent>
                </Select>
                {fieldState.error && (
                  <p className="text-xs text-red-600 mt-1">{fieldState.error.message}</p>
                )}
              </>
            )}
          />
          <p className="text-sm text-gray-600 mt-1">
            This coverage requires a signed interchange agreement.
          </p>
        </div>
      )}
    </div>
  );
}
